module.exports = __webpack_public_path__ + "static/media/icon_cream.af78f672.svg";